exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#imgActivity{height:100px;padding:15px;margin:5px;border:2px dotted #dcdcdc}#close{float:left;padding:5px}", "", {"version":3,"sources":["/home/circleci/repo/src/components/CreateActivityComponent.vue"],"names":[],"mappings":"AACA,aAGE,aAAc,AACd,aAAc,AACd,WAAY,AACZ,yBAAwB,CACzB,AACD,OACE,WAAY,AACZ,WAAiB,CAClB","file":"CreateActivityComponent.vue","sourcesContent":["\n#imgActivity {\n  border-style: dotted;\n  border-width: 2px;\n  height: 100px;\n  padding: 15px;\n  margin: 5px;\n  border-color: gainsboro;\n}\n#close {\n  float: left;\n  padding: 5px 5px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37a679a3","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CreateActivityComponent.vue
// module id = 1156
// module chunks = 16 17